module.exports = __webpack_public_path__ + "img/features1.f3da8c01.png";